<div class="p16">
    <div class="header-dialog">
        <span (click)="close()">x</span>
    </div>
    <trent-pts-enquiry-form [type]="type" (closeDialog)="close()" [productDetails]="productDetails"></trent-pts-enquiry-form>
</div>